import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { withRouter, Link } from 'react-router-dom'
import VendorCard from '../vendor_assessments/conponents/vendor-card'

class SecurityAwareness extends Component {
  render () {
    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className='page-title'>Vendor Assessments</h3>
            <h3 className='page-subhead subhead'>Overview of your Vendor Assessments</h3>
            <Link
              style={{ float: 'right' }}
              className={`dashboard btn btn-primary add-compliance`}
              to='/app/vendor-assessments/view'>
              View Assessment
            </Link>
          </Col>

        </Row>
        <Row>
          <Link to='/app/vendor-assessments/results'>
            <VendorCard
              id=''
              category='Company LLC Risk Assessment'
              percentage='57'
              numberCompliance={20}
              totalControls={47}
              clickable
              percentage_color={'#2d9aa6'}
              hoverColor
              isActive={false}
              bgColor='white-bg'
            />
          </Link>
        </Row>
      </Container>
    )
  }
}

export default withRouter(SecurityAwareness)



// WEBPACK FOOTER //
// ./src/components/vendor_assessments_home/VendorAssessmentsHome.js